import React from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { BASE_URL } from '../constants';

import "swiper/css";
import "swiper/css/navigation";

const IMAGE_BASE_URL = BASE_URL;

const JewelleryCategories = ({ category = [] }) => {
  return (
    <section className="py-5">
      <style>
        {`
          .category-card {
            position: relative;
            overflow: hidden;
            cursor: pointer;
          }

          .category-card img {
            width: 100%;
            height: 300px;
            object-fit: cover;
            transition: transform 0.4s ease;
          }

          .category-card:hover img {
            transform: scale(1.05);
          }

          

          

          .category-label {
                position: absolute;
                border-radius: 5px;
                bottom: 12px;
                left: 12px;
                color: #fff;
                font-size: 12px;
                letter-spacing: 1px;
                background: rgb(0 0 0 / 15%);
                padding: 4px 8px;
          }

          .swiper-button-next,
          .swiper-button-prev {
            color: #000;
            width: 32px;
            height: 32px;
          }
          
          
        `}
      </style>

      <Container fluid>
        <div className="discover-heading">
          <span>Discover by</span>
          <h2>CATEGORY</h2>
        </div>

        <Swiper
          modules={[Autoplay, Navigation]}
          spaceBetween={5}
          navigation={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            320: {
              slidesPerView: 2,
            },
            576: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 4,
            },
            992: {
              slidesPerView: 5,
            },
            1200: {
              slidesPerView: 5,
            },
          }}
        >
          {category.map((item, index) => (
             
            <SwiperSlide key={index}>
              <Link
                to={`/collection/${item.slug}`}
                style={{ textDecoration: "none" }}
              >
                <div className="category-card">
                  <img src={`${IMAGE_BASE_URL}/${item.image}`} alt={item.title} />
                  <div className="category-label">{item.name}</div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default JewelleryCategories;
